import React, { useState } from 'react';
import { Button, message, Modal } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { t } from '../../../../i18n';

interface ShippingLabelExportSuccessModalProps {
    visible: boolean;
    onClose: () => void;
    fileName: string;
}

/**
 * 总部包裹「导出面单」异步任务提交成功后的提示弹窗。
 */
const ShippingLabelExportSuccessModal: React.FC<ShippingLabelExportSuccessModalProps> = ({
    visible,
    onClose,
    fileName,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [copyLoading, setCopyLoading] = useState(false);

    const handleCopyFileName = async () => {
        setCopyLoading(true);
        try {
            await navigator.clipboard.writeText(fileName);
            message.success(t('delivery.parcels.message.downloadCopySuccess'));
        } catch {
            message.error(t('delivery.parcels.message.downloadCopyFailed'));
        } finally {
            setCopyLoading(false);
        }
    };

    const handleGoToDownloadPage = () => {
        if (location.pathname.includes('/qualitycontrol')) {
            navigate('/qualitycontrol/download');
        } else {
            navigate('/central/download');
        }
        onClose();
    };

    return (
        <Modal
            title={
                <div className="flex items-center">
                    <div className="mr-3 h-6 w-1 bg-purple-500" />
                    <span className="text-base font-medium">
                        {t('central.parcels.exportShippingLabel.successModalTitle')}
                    </span>
                </div>
            }
            open={visible}
            onCancel={onClose}
            width={520}
            footer={[
                <Button key="close" onClick={onClose}>
                    {t('components.button.close')}
                </Button>,
                <Button key="copy" icon={<CopyOutlined />} loading={copyLoading} onClick={handleCopyFileName}>
                    {t('components.button.copyFilename')}
                </Button>,
                <Button key="download" type="primary" onClick={handleGoToDownloadPage}>
                    {t('components.button.goToDownloadPage')}
                </Button>,
            ]}
        >
            <div className="py-3">
                <p className="mb-3 font-medium text-gray-800">
                    {t('central.parcels.exportShippingLabel.successModalDescription')}
                </p>
                <div className="mb-2 rounded-lg bg-gray-50 p-3">
                    <span className="font-medium">{t('delivery.parcels.label.filename')}: </span>
                    <code className="break-all">{fileName}</code>
                </div>
            </div>
        </Modal>
    );
};

export default ShippingLabelExportSuccessModal;
